import { segments } from '@/constants/countryList';
import {
  domain,
  isLocalhost,
  isDev,
  isUat,
} from '@/plugins/domain';

const { origin } = window.location;

const apiUrl = {
  prod: 'https://api-smpodbor.sportmaster.ru/api/',
  dev: 'https://web-api-dev.smpodbor-dev.k8s.dark.sportmaster.com/api/',
  uat: 'https://web-api-preprod.smpodbor-preprod.k8s.dark.sportmaster.com/api/',
};

export function setBaseURL() {
  if (isLocalhost || isDev) {
    return apiUrl.dev;
  }

  if (isUat) {
    return apiUrl.uat;
  }

  if (domain) {
    switch (domain) {
      case 'ru':
        return apiUrl.prod;
      default:
        return `${origin}/api`;
    }
  }

  throw new Error('Unsupported URL');
}

export function setSegment() {
  switch (domain) {
    case 'ru':
      return segments.SPORTMASTER;
    case 'by':
      return segments.SPORTMASTER_BY;
    case 'am':
      return segments.SPORTMASTER_AM;
    case 'kg':
      return segments.SPORTMASTER_KG;
    case 'kz':
      return segments.SPORTMASTER_KZ;
    case 'uz':
      return segments.SPORTMASTER_UZ;
    default:
      return segments.SPORTMASTER;
  }
}
